import React from "react";
import BlogsHero from "./BlogsHero";
import BlogSection from "./BlogPageList";
import Footer from "../Footer";

const BlogLandingPage = () => {
  return (
    <div>
      <div className="p-4 pt-24 md:pt-32 md:p-24 2xl:p-48 bg-gray-50">
        <BlogsHero />
        {/* devider line */}
        <div className="border-t border-gray-300 my-8"></div>
        <BlogSection />
      </div>
      <Footer />
    </div>
  );
};

export default BlogLandingPage;
